import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const advantages = [
    { icon: 'ri-focus-2-line', text: 'Индивидуальная программа под задачи бизнеса' },
    { icon: 'ri-tools-fill', text: '80% практики, реальные кейсы компании' },
    { icon: 'ri-bar-chart-grouped-line', text: 'Измеримый рост конверсии и прибыли' },
    { icon: 'ri-user-heart-line', text: 'Сопровождение после обучения' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/e710e42b-e287-430c-bcda-0bcd98ae0d26_compressed_IMG_1156.webp"
          alt="Алексей Сивко — обучение отдела продаж"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="max-w-3xl">
          <div className="text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight">
              Обучение отдела продаж
            </h1>
            <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed">
              Корпоративное обучение менеджеров по продажам с диагностикой, практикой и сопровождением внедрения
            </p>

            {/* Преимущества */}
            <div className="space-y-3 mb-8">
              {advantages.map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/80 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-sm text-white`}></i>
                  </div>
                  <span className="text-sm md:text-base">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Кнопки */}
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                Заказать тренинг отдела продаж
                <i className="ri-arrow-right-line"></i>
              </button>
              <LeadMagnetHeroTeaser />
            </div>
            <p className="text-white/50 text-xs mt-3">
              Отвечаю лично в течение одного рабочего дня. Стоимость зависит от формата, длительности и числа участников.
            </p>
          </div>


        </div>
      </div>
    </section>
  );
}